e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                // Varniants is not yet ready for production.
                e4.product.variants.init();
            } );
        }
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery(document).on('productadded.e4.cart', function(){
            jQuery('.js-olino-input-groupid').val(e4.product.getGeneratedGUID());
        });
        
        jQuery(document).on('mouseleave mouseenter slide slid touchend keydown load click touchend', '.js-uniforms-video-carousel-item, .js-uniforms-video-carousel-item *', function(event){
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            if ( ( event.type === 'click' || event.type === 'touchend' ) && event.isTrigger === undefined ){
                jQuery('#uniforms-video-modal').modal('show');
            }
        });

        jQuery( '#uniforms-video-modal' ).on( 'shown.bs.modal', function ( event ) {
            const video = document.getElementById( "product-video" );
            video.play();
        } );

        jQuery( '#uniforms-video-modal' ).on( 'hide.bs.modal', function ( event ) {
            const video = document.getElementById( "product-video" );
            video.pause();
            video.currentTime = 0;
        } );

        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        
        if ( jQuery( '.js-e-product-favorite-list-form' ).length > 0 ) {
            e4.product.favoritelist.bindEvents();
        }
        if( jQuery('.js-olino-relatedproducts-group').length > 0 ){
            jQuery('.js-olino-relatedproducts-group').on('change', '.js-olino-relatedproducts-group-input', function(event){
                var jInput = jQuery(event.currentTarget);
                if(jInput.hasClass('js-olino-select')){
                    jInput = jInput.find('option:selected');
                }

                var jGroupElement = jInput.closest('.js-olino-relatedproducts-group'),
                    jInputQuantity = jInput.closest( '.js-e-product-form' ).find('.js-olino-main-input-quantity'),
                    jInputVal = jInput.val();

                if(jInputVal !== '0'){
                    jInputVal = jInputQuantity.val();
                }

                jQuery('.js-olino-input-groupid').val(e4.product.getGeneratedGUID());
                jGroupElement.find('.js-olino-relatedproduct-productid').val(jInput.data('productId'));
                jGroupElement.find('.js-olino-relatedproduct-variantid').val(jInput.data('productVariantid'));
                jGroupElement.find('.js-olino-relatedproduct-quantity').val(jInputVal);
                jGroupElement.find('.js-olino-input-price').val(jInput.data('price'));
                e4.product.setCalculateTotalPrice(event);
            });
            jQuery('.js-olino-relatedproducts-group').find('.js-olino-relatedproducts-group-input').eq(0).trigger('change');

        }

        jQuery( '.js-e-product-form' ).on('change', '.js-olino-input-quantity', function(event){
            var jInput = jQuery(event.currentTarget);
            jQuery('.js-olino-relatedproducts-group').each(function(intIndex, domElement){
                var jGroupElement = jQuery(domElement);
                if(jGroupElement.find('.js-olino-relatedproduct-productid').val() !== ''){
                    jGroupElement.find('.js-olino-relatedproduct-quantity').val(jInput.val());
                }
            });
            e4.product.setCalculateTotalPrice(event);
        });


    },
    setCalculateTotalPrice: function(event){
        var dblTotalPrice = 0.00;
        jQuery('.js-olino-product-to-cart-group').each(function(intIndex, domElement){
            var jGroup = jQuery(domElement),
                intQuantity = jGroup.find('.js-olino-input-quantity').val(),
                dblPrice = jGroup.find('.js-olino-input-price').val(),
                dblGroupPrice = (intQuantity * dblPrice);
            if(!isNaN(dblGroupPrice)){
                dblTotalPrice = dblTotalPrice + dblGroupPrice;
            }
        });
        jQuery('.js-olino-total-price').text(e4.product.getFormattedPrice(dblTotalPrice, true));
    },
    getFormattedPrice: function(dblPrice, includeCurrency) {
        var cartForm = jQuery('.js-olino-product-form-addtocart'),
            charDecimalSeparator = cartForm.data('currencydecimalseparator'),
            charGroupSeparator = cartForm.data('currencygroupseparator'),
            strCurrencyCode = cartForm.data('currencycode'),
            strCurrencysymbol = cartForm.data('currencysymbol'),
            intCurrencysymbolplace = cartForm.data('currencysymbolplace'),
            returnValue = dblPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        returnValue = returnValue.split('.').join('_');
        returnValue = returnValue.split(',').join(charGroupSeparator);
        returnValue = returnValue.split('_').join(charDecimalSeparator);
        if(includeCurrency){
            if(intCurrencysymbolplace === 0){
                returnValue = returnValue + ' ' + strCurrencyCode;
            } else {
                returnValue = strCurrencysymbol + ' ' + returnValue;
            }
        }
        return returnValue;
    },
    getGeneratedGUID: function() {
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if(d > 0){//Use timestamp until depleted
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};

        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    favoritelist: {
        bindEvents: function () {
            jQuery( '.js-e-product-favorite-list-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
            } ).on( 'change', '.js-e-favorite-list', function ( event ) {
                e4.product.favoritelist.toggleList( event.target );
            } );
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.product.favoritelist.addToList( jInput );
            }
            else {
                e4.product.favoritelist.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-add' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        }
    }
};
